import { MagicCard } from "@apiserver-rest/ponder-data-client-base";
import { getBit } from "@ponder-shared/utils/bitOperations";

export enum MagicColorFlag {
    Unknown    = 0b00000000,
    White      = 0b00000001,
    Blue       = 0b00000010,
    Black      = 0b00000100,
    Red        = 0b00001000,
    Green      = 0b00010000,
    Colorless  = 0b00100000,        // For mana-production only
    All        = 0b11111111         // For mana-production only
};

export function isWhite(card: MagicCard): boolean {
    return getBit(card.colorMask, 0) == 1;
}

export function isBlue(card: MagicCard): boolean {
    return getBit(card.colorMask, 1) == 1;
}

export function isBlack(card: MagicCard): boolean {
    return getBit(card.colorMask, 2) == 1;
}

export function isRed(card: MagicCard): boolean {
    return getBit(card.colorMask, 3) == 1;
}

export function isGreen(card: MagicCard): boolean {
    return getBit(card.colorMask, 4) == 1;
}

export function isMulticolor(card: MagicCard): boolean {
    // https://stackoverflow.com/a/28303898/735425
    return (card.colorMask & (card.colorMask - 1)) != 0;
}

export function isColorless(card: MagicCard): boolean {
    return card.colorMask == 0;
}

export function producesWhite(card: MagicCard): boolean {
    return card.manaMask ? getBit(card.manaMask, 0) == 1 : false;
}

export function producesBlue(card: MagicCard): boolean {
    return card.manaMask ? getBit(card.manaMask, 1) == 1 : false;
}

export function producesBlack(card: MagicCard): boolean {
    return card.manaMask ? getBit(card.manaMask, 2) == 1 : false;
}

export function producesRed(card: MagicCard): boolean {
    return card.manaMask ? getBit(card.manaMask, 3) == 1 : false;
}

export function producesGreen(card: MagicCard): boolean {
    return card.manaMask ? getBit(card.manaMask, 4) == 1 : false;
}

export function producesColorless(card: MagicCard): boolean {
    return card.manaMask ? getBit(card.manaMask, 5) == 1 : false;
}

export function producesAll(card: MagicCard): boolean {
    return card.manaMask ? getBit(card.manaMask, 6) == 1 : false;
}